<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-button id="table-settings" size="sm" variant="warning" class="mr-2" v-b-toggle.sidebar-fields>
          <font-awesome-icon icon="cog" />
        </b-button>
        <b-tooltip target="table-settings" triggers="hover" variant="warning" noninteractive>
          Колонки
        </b-tooltip>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-row>
          <b-col cols="auto">
            <b-btn v-if="canEditUsers()" size="sm" variant="success" class="ml-1" :disabled="isBusy" @click="onCreate()">
              <b-spinner v-if="isBusy" small/>
              <font-awesome-icon icon="plus" class="mr-1"/>
              {{ $t("message.workers.importHand") }}
            </b-btn>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-navbar variant="light">
      <b-navbar-nav>
        <filters-drawer
          :query.sync="filters.query"
          :is-busy="isBusy"
          @submit="onSearch"
        />
      </b-navbar-nav>
    </b-navbar>

    <b-table
      id="users"
      ref="usersTable"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy.sync="isBusy"
      :items="items"
      :fields="renderedFields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      no-local-sorting
      @sort-changed="sortChanged"
      @row-dblclicked="onRowClicked"
      sticky-header
      head-variant="light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загрузка</strong>
        </div>
      </template>
      <template #cell(action)="row">
        <b-btn v-if="canEditUsers()" size="sm" variant="primary" @click="onEdit(row.item)">
          <font-awesome-icon icon="edit"/>
        </b-btn>
      </template>
      <template #cell(active)="row">
        <font-awesome-icon v-if="!row.item.active" icon="times"/>
        <font-awesome-icon v-if="row.item.active" icon="check"/>
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    />

    <DynamicTables
      storage-key="users_columns"
      sidebar-fields="sidebar-fields"
      :fields-model.sync="fields"
      :serviceEndField="serviceEndField"
      fieldKey="id"
    />

  </div>
</template>

<script>
import users from "../../network/users";
  import helpers from "../../utilites/helpers";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
  import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
  import permissions, {PERM} from "../../utilites/permissions";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";

export default {
  name: "Users",
  components: { PaginationFooter, FiltersDrawer, DynamicTables },
  mixins: [
    users,
    helpers, permissions, pageSearchService
  ],
  data() {
    return {
      title: "Пользователи",
      query: '',
      isBusy: false,
      items: [],
      fields: [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          class: 'usersId',
          visible: true,
        },
        {
          key: 'username',
          label: 'username',
          sortable: true,
          visible: true,
        },
        {
          key: 'name',
          label: "Имя",
          sortable: true,
          visible: true,
        },
        {
          key: 'role_name',
          label: "Роль",
          sortable: true,
          visible: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
          visible: true,
        },
      ],
      serviceEndField: {
        key: 'action',
        label: "Действия",
        class: 'usersAction'
      },
      sortBy: 'id',
      sortDesc: true,
      filters: {
        query: '',
      },
      deleteRow: {
        id: null,
        name: '',
        username: ''
      },
    }
  },
  async created() {
    const query = this.$route.query;

    if (query && query.query) {
      this.filters.query = query.query;
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    await this.onSearch();
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible);
    },
    renderedFields() {
      return [
        ...this.visibleFields,
        this.serviceEndField
      ];
    }
  },
  methods: {
    onCreate() {
      if (this.hasPermission([PERM.USER_EDIT])) {
        this.$router.push({name: 'UserAdd'}).catch(()=>{});
      }
    },
    onEdit(item) {
      if (this.hasPermission([PERM.USER_EDIT])) {
        this.$router.push({
          name: 'UserEdit',
          params: { user_id: item.id},
          query: this.$route.query,
          hash: this.$route.hash
        }).catch(()=>{});
      }
    },
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      }

      this.isBusy = true;
      const result = await this.getUsers(data);
      this.isBusy = false;

      if (!result || !result.data) {
        this.items = [];
        this.totalRows = 0;
        const mess = "Что-то пошло не так. Попробуйте обновить страницу и повторить действие."
        this.showError(mess);
        return;
      }

      this.items = result.data.users;
      this.totalRows = result.data.total;
    },
    onRowClicked(item) {
      this.onEdit(item);
    },
    // Permissions
    canEditUsers() {
      return this.hasPermission([PERM.USER_EDIT]);
    }
  },
}
</script>
<style>
.usersId {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.usersAction {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}

#users td {
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Users.vue